module.exports = __webpack_public_path__ + "img/perpendicular-lines.29ac561.png";